
import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-background border-t py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/lovable-uploads/de3d0bc8-0f94-4be8-9cb4-e571559a9a53.png"
                alt="Mate4Tech Logo"
                className="h-8 w-auto"
              />
              <span className="font-semibold">Knowledge Hub</span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground">
              Comprehensive technical guides and tutorials for modern technology professionals.
            </p>
            <a 
              href="https://mate4tech.com.au" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-1 mt-3 text-sm text-primary hover:underline"
            >
              Visit Mate4Tech Pty Ltd <ExternalLink className="h-3 w-3" />
            </a>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/tutorials" className="text-muted-foreground hover:text-primary">
                  All Tutorials
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-muted-foreground hover:text-primary">
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/latest" className="text-muted-foreground hover:text-primary">
                  Latest Content
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Connect</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://twitter.com/mate4tech" className="text-muted-foreground hover:text-primary flex items-center gap-1">
                  Twitter <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a href="https://github.com/mate4tech" className="text-muted-foreground hover:text-primary flex items-center gap-1">
                  GitHub <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary">
                  Discord Community
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Mate4Tech Pty Ltd. All rights reserved.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
